class FooterMenuAccordion {
  constructor() {
    this.details = document.querySelectorAll('.footer-block--menu .footer-block__details');
    if (!this.details.length) return;

    this.mediaQuery = window.matchMedia('(max-width: 749px)');
    this.mediaQuery.addEventListener('change', () => this.sync());
    this.sync();
  }

  sync() {
    const isMobile = this.mediaQuery.matches;

    this.details.forEach((detail) => {
      if (isMobile) {
        detail.removeAttribute('open');
      } else {
        detail.setAttribute('open', '');
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new FooterMenuAccordion());
} else {
  new FooterMenuAccordion();
}
